var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardiconnn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5382 6.76675C16.5066 6.76675 20.4751 6.76675 24.4436 6.76675C24.9904 6.76675 24.9904 6.77455 24.9904 7.31262C24.9904 9.94834 24.9904 12.5841 24.9904 15.2276C24.9904 16.9198 23.8186 18.0817 22.1156 18.0817C15.702 18.0817 9.28058 18.0817 2.86698 18.0817C1.17179 18.0739 0 16.912 0 15.2198C0 12.5841 0 9.94834 0 7.30482C0 6.77455 0.00781193 6.76675 0.554648 6.76675C4.54655 6.76675 8.54626 6.76675 12.5382 6.76675ZM6.24955 13.0286C6.26518 12.6309 6.28861 12.241 5.90583 11.9758C5.60897 11.7731 4.55436 11.7731 4.25751 11.9758C3.74192 12.3189 3.74192 13.6758 4.25751 14.0345C4.56217 14.245 5.60116 14.245 5.90583 14.0345C6.27299 13.785 6.26518 13.4107 6.24955 13.0286Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 5.2072C8.55464 5.2072 4.61742 5.2072 0.672393 5.2072C0.000566055 5.2072 -0.0228698 5.2072 0.008378 4.51317C0.0318138 3.92053 0.0161899 3.30448 0.180241 2.75082C0.508342 1.62791 1.54733 0.926087 2.71912 0.918289C9.23428 0.918289 15.7572 0.918289 22.2724 0.926087C23.7957 0.926087 24.9831 2.13478 24.991 3.65539C24.991 4.0297 24.9753 4.4118 24.9988 4.7861C25.0144 5.10582 24.8816 5.22279 24.5613 5.215C23.5223 5.1994 22.4755 5.2072 21.4365 5.2072C18.4602 5.2072 15.4838 5.2072 12.4997 5.2072Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardiconnn);
export default __webpack_public_path__ + "static/media/CreditCardiconnn.0eeec9dfb7febb1b8bb9e0a2064eab21.svg";
export { ForwardRef as ReactComponent };